import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import logo1 from '../../images/logo/NCRI.jpg';
import logo2 from '../../images/logo/aser.jpg';
import logo3 from '../../images/logo/cswb.jpg';
import logo4 from '../../images/logo/epco bhopal.jpg';
import logo5 from '../../images/logo/gov of mp.png';
import logo6 from '../../images/logo/handicraft.png';
import logo7 from '../../images/logo/medicinal plant board.jpg';
import logo8 from '../../images/logo/nabard.png';
import logo9 from '../../images/logo/science and technology.jpg';
import logo10 from '../../images/logo/tribal affairs.jpg';
import logo11 from '../../images/logo/azimpremji.jpeg';
// import logo12 from '../../images/logo/science and technology.jpg';
// import logo13 from '../../images/logo/science and technology.jpg';
// import logo14 from '../../images/logo/science and technology.jpg';







const Ourpartner = () => {
  return (
    <>
      {/* ==== Banner Section Start ==== */}
     
      <div className='container'> 


      <section  className="banner client-logo">
      <div className="title-area text-center">
            {/* <span className="sub-title after-none before-none">
              OUR &amp; CLINT
            </span> */}
            <h2 className="sec-title">Our Partners</h2>
          </div>
          <div className="slider-area">
            {/* Add any additional HTML content here */}
          </div>
        <OwlCarousel
          className="owl-theme"
          loop
          margin={10}
          nav
          autoplay
          autoplayTimeout={3000}
          items={8}
        >
          <div className="item">
          <img
                      src={logo1}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo2}
                      alt="Service 1"
                    />
          </div>


          <div className="item">
          <img
                      src={logo3}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo4}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo5}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo6}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo7}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo8}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo9}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo10}
                      alt="Service 1"
                    />
          </div>

          <div className="item">
          <img
                      src={logo11}
                      alt="Service 1"
                    />
          </div>
         


         

        
       
         
        </OwlCarousel>
      </section>
      </div>
      {/* ==== Banner Section End ==== */}
    </>
  );
};

export default Ourpartner;
